import { appendElement, appendElementIf } from '../xml-helpers';

export function buildPublisher(
  parent: Element,
  publisherName: string
): Element {
  const publisher = appendElement(parent, 'publisher');
  appendElement(publisher, 'publisher_name', publisherName);
  return publisher;
}
